import { type FC } from "react";
import StarIcon from "../../../components/icons/StarIcon";
import { Slot, Templated } from "../../../templating";

interface ChatMessageListRatingDisplayItemProps {
  message: string;
}

const ChatMessageListRatingDisplayItem: FC<ChatMessageListRatingDisplayItemProps> = ({ message }) => {
  // Extract rating value and label from message
  // Message format: "{{★★★}} Good" or similar
  const ratingMatch = message.match(/\{\{(★+)\}\}\s*(.*)/);
  const ratingValue = ratingMatch ? ratingMatch[1].length : 0;
  const ratingLabel = ratingMatch ? ratingMatch[2].trim() : "";

  return (
    <Templated id="lastbot-rating-display">
      <div className="flex gap-x-4 justify-end">
        <div className="shrink-0 w-[30px]"></div>
        <div className="p-4 rounded-lg rounded-tr-none bg-lastbot-bubble-user-surface text-right text-lastbot-on-surface flex gap-x-2 items-center">
          <Slot name="stars">
            <div className="flex" data-testid={`rating-stars`}>
              {Array.from({ length: ratingValue }, (_, i) => (
                <StarIcon key={i} size="small" active />
              ))}
            </div>
          </Slot>
          <Slot name="feedback-input">
            <div>{ratingLabel}</div>
          </Slot>
        </div>
      </div>
    </Templated>
  );
};

export default ChatMessageListRatingDisplayItem;
